import axios from 'axios'
import router from '../router'
import qs from 'qs'
// import { BASE_URL, BASE_URL_PROD } from './config'
import { Message, Loading } from 'element-ui'

const config = require('./_config_' + process.env.VUE_APP_ENV)
let loadingInstance

// const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {}

const http = axios.create({
  timeout: 1000 * 60 * 5,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  loadingInstance = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(243, 243, 243, 0.1)'
  })
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data && response.data.result === 3) { // 登录超时
    router.push({ name: 'login' })
  }
  loadingInstance.close()
  if (response.data && (response.data.result === 1 || response.data.result === 2)) {
    Message.error(response.data.msg)
    throw Error(response.data.msg)
  }
  return response.data
}, error => {
  loadingInstance.close()
  Message.error('服务器错误，请联系管理员')
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // 非生产环境
  return config.BASE_URL + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {}
  return openDefultParams ? Object.assign({}, defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, contentType = 'json') => {
  if (contentType === 'form') {
    http.defaults.headers['Content-Type'] = 'multipart/form-data'
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key])
    })
    return formData
  } else if (contentType === 'file') {
    http.defaults.headers['Content-Type'] = 'multipart/form-data'
    return data
  }
  http.defaults.headers['Content-Type'] = 'application/json; charset=UTF-8'
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http
